export default __webpack_public_path__ + "static/media/103213.71fe0fba.jpg";